import React from 'react';
import { Box, useTheme } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useStyles from './styles';

const Loading = () => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Box className={`loading ${classes.container}`}>
      <Box
        className="header-bar"
        alignItems="center"
        justifyContent="flex-end"
        display="flex"
      >
        <Skeleton variant="text" width="100px" />
        <Box ml={1} mr={3}>
          <Skeleton variant="circle" width={24} height={24} />
        </Box>
      </Box>
      {[1, 2, 3].map(item => (
        <Box
          key={item}
          display="flex"
          height={theme.spacing(6)}
          alignItems="center"
          px={3}
        >
          <Box mr={3}>
            <Skeleton variant="circle" width={24} height={24} />
          </Box>
          <Skeleton variant="text" width="120px" />
        </Box>
      ))}
    </Box>
  );
};

export default Loading;
